export default __webpack_public_path__ + "static/media/DiplomaticoOpen.b9505a72.jpg";